export default __webpack_public_path__ + "locales/fr/InviteDialog.json?hash=29f347301f08a9119c10ce1bd3e298a0";